import TonWeb from "tonweb";

export const sleep = (time: number) =>
  new Promise(resolve => setTimeout(resolve, time));

export function getSignableMessage(): string {
  const dt = new Date().getTime();
  return "auth_" + String(dt - (dt % 600000));
}

export const formatTonAddress = (address: string): string => {
  if (!address) return "";
  try {
    // Convert raw address to user-friendly format
    const rawAddress = new TonWeb.utils.Address(address);
    const userFriendlyAddress = rawAddress.toString(true, true, true);
    return userFriendlyAddress;
  } catch (e) {
    return address;
  }
};

export const isSystemIOS = () => {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;
  return /iPad|iPhone|iPod/.test(userAgent);
};

export const formatUTCDate = (timestamp: number) => {
  if (!timestamp) return "No time limit";
  const date = new Date(timestamp);
  return (
    date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      })
      .replace(",", "") + " (UTC)"
  );
};
